import React from 'react';
import { Link } from 'react-router-dom';
import { formatPrice } from '../utils/priceHelpers';

const ProductCard = ({ product }) => {
  const thumb = product.thumbnailUrl || product.images?.[0];
  const outOfStock = (product.stock ?? 0) <= 0;

  return (
    <Link
      to={`/shop/${product.id}`}
      className="card"
      style={{
        display: 'block',
        textDecoration: 'none',
        color: 'inherit',
        overflow: 'hidden',
        opacity: outOfStock ? 0.75 : 1,
      }}
    >
      <div
        style={{
          height: 200,
          background: '#f5f5f5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        {thumb ? (
          <img
            src={thumb}
            alt={product.name}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        ) : (
          <span style={{ fontSize: 48 }}>📦</span>
        )}
      </div>
      <div style={{ padding: '16px' }}>
        <h3 style={{ fontSize: 16, margin: '0 0 8px', lineHeight: 1.3 }}>{product.name}</h3>
        <p style={{ margin: 0, fontWeight: 'bold', color: '#FF0000', fontSize: 18 }}>
          {formatPrice(product.price)}
        </p>
        {outOfStock ? (
          <span style={{ fontSize: 12, color: '#dc3545' }}>Rupture de stock</span>
        ) : (
          <span style={{ fontSize: 12, color: '#666' }}>{product.stock} en stock</span>
        )}
      </div>
    </Link>
  );
};

export default ProductCard;
